import { useEffect } from 'react';

import { styled } from '@mui/system';
import {
  Experimental_CssVarsProvider as CssVarsProvider,
  experimental_extendTheme as extendTheme }
  from '@mui/material/styles';
import CssBaseline from "@mui/material/CssBaseline";
import * as locales from '@mui/material/locale';

import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

import { sharedThemeOptions } from './themes/sharedThemeOptions';
import clsx from 'clsx';
import { rtlLanguages } from 'assets/constants';
import { searchQuery } from 'utils';

const PreventTextSelection = styled('div')(() => ({
  '&.isPreview': { background: 'transparent' },
  "& span, & header, & p, & h1, & h2, & h3, & h4, & h5, & h6": { //disable text selection
    userSelect: 'none', // Chrome, Edge, Opera and Firefox
    WebkitTouchCallout: 'none', // iOS Safari
    WebkitUserSelect: 'none',// Safari
  }
}));

const caches = {
  'rtl': createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin]
  }),
  'ltr': createCache({
    key: 'muiltr',
    stylisPlugins: [prefixer]
  })
}

const isPreview = searchQuery('p') === 't';

export const OnlineBookingTheme = ({ lngCode, children }) => { // TODO [GM]: direction
  const direction = rtlLanguages.includes(lngCode) ? 'rtl' : 'ltr';
  useEffect(() => {
    document.documentElement.dir = direction
    document.documentElement.lang = lngCode
  }, [direction, lngCode]);

  const theme = extendTheme({
    ...sharedThemeOptions, direction
  }, locales[lngCode]);

  return (
    <CacheProvider value={caches[direction]} >
      <CssVarsProvider theme={theme} >
        <CssBaseline />
        <PreventTextSelection className={clsx({ isPreview })}>
          {children}
        </PreventTextSelection>
      </CssVarsProvider>
    </CacheProvider >
  );
}
